import React from "react";
import {
  Button,
  Form,
  FormGroup,
  Modal,
  Radio,
  RadioGroup,
  Row,
  Col,
  Alert,
  Slider,
  ControlLabel,
  Icon,
  FormControl,
} from "rsuite";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectReportsModal } from "../../redux/modals/modals.selector";
import modalsTypes from "../../redux/modals/modals.types";
import {
  selectReports,
  selectSelectedCarInfo,
  selectDay,
  selectCarsData,
  selectPlayPause,
  selectInterval,
  selectReportIndex,
  selectCarIcons,
  selectReportSpeed,
  selectArrowIcon,
  selectSingleCarData,
  selectEndRepTime,
  selectStartRepTime,
} from "../../redux/cars/cars.selector";
import { selectToken, selectUserInfo } from "../../redux/user/user.selector";
import Axios from "axios";
import {
  ChangeDay,
  GetCarsData,
  GetReports,
  SetArrowIcon,
  SetEndtRepTime,
  SetInterval,
  SetReportIndex,
  SetReportSpeed,
  SetStartRepTime,
} from "../../redux/cars/cars.action";
import { antPath } from "leaflet-ant-path";
import {
  selectIconsLayer,
  selectIsLive,
  selectIsMain,
  selectMap,
  selectReportLayer,
} from "../../redux/map/map.selector";
import * as L from "leaflet";
import "leaflet-easybutton";
import startMark from "../../assets/icons/flag.png";
import endMark from "../../assets/icons/flag2.png";
import carsTypes from "../../redux/cars/cars.types";
import Play from "../../assets/icons/play.png";
import Pause from "../../assets/icons/pause.png";
import { AddReportLayer, SetIconsLayer } from "../../redux/map/map.actions";
import buttonOff from "../../assets/icons/delete.png";
import Arrow from "../../assets/icons/lock_back1.png";
import "leaflet-rotatedmarker";
import "leaflet-easybutton/src/easy-button.css";
import "./reports.Style.sass";
import "@elfalem/leaflet-curve";
import "leaflet.polyline.snakeanim";
import ParkIcon from "../../assets/icons/park_red.png";
import mapTypes from "../../redux/map/map.types";
import carSeek from "../../assets/icons/car_seek.png";
import { selectReceivedExcel } from "../../redux/form/form.selector";
import { SetReceivedExcel } from "../../redux/form/form.actions";
import { handleJoinDateFromObj, ToPersianDate } from "../../script";
import DatePicker, { Calendar } from "react-modern-calendar-datepicker";
import jMoment from "moment-jalaali";
import moment from "moment";

class ReportsComponent extends React.Component {
  constructor(props) {
    super(props);
    const formValue = {
      period: 0,
      speed: 200,
    };
    this.state = {
      formValue: formValue,
      loading: false,
      selectedDay: {
        from: null,
        to: null,
      },
    };
  }

  componentDidMount() {
    const { setEndRepTime, setStartRepTime } = this.props;
    setEndRepTime(Date());
    setStartRepTime(Date());
  }

  render() {
    const {
      ReportsModal,
      SetIconsLayer,
      getReports,
      ToggleReports,
      CarData,
      getUser,
      setReports,
      Day,
      ChangeDay,
      getMap,
      getMarkerLayers,
      TogglePlayPause,
      playPause,
      SetInterval,
      getInterval,
      SetReportIndex,
      getReportIndex,
      addReportLayer,
      getReportLayer,
      ClearReportLayer,
      setReportSpeed,
      getReportSpeed,
      singleCar,
      ClearIconsLayer,
      isLive,
      isMain,
      ToggleIsLive,
      ToggleIsMain,
      getArrowIcon,
      SetArrowIcon,
      getToken,
    } = this.props;
    const { formValue, selectedDay } = this.state;
    let map = getMap;

    /** Handle Get EXCEL */
    const handleGetExcel = () => {
      let url = `${getToken}/getReports?phone=${getUser.phone}&id=${CarData.ID}&pass=${getUser.pass}&type="excel"&`;
      if (Day === "time") {
        console.log("selectedDay : ", selectedDay);
        const timeStart = document.getElementById("report_time_start");
        const timeEnd = document.getElementById("report_time_end");

        let from = jMoment(
          `${handleJoinDateFromObj(selectedDay.from)} ${timeStart.value}`,
          "jYYYY-jM-jD HH:mm"
        ).format("YYYY/M/D HH:mm");

        let to = jMoment(
          `${handleJoinDateFromObj(selectedDay.to)} ${timeEnd.value}`,
          "jYYYY-jM-jD HH:mm"
        ).format("YYYY/M/D HH:mm");

        let startTime = new Date(from).getTime();
        let tillTime = new Date(to).getTime();
        url += `startTime=${startTime}&tillTime=${tillTime}`;
      } else {
        url += `day=${Day}`;
      }
      window.open(`${url}`, "_blank");
    };

    /** HANDLE SUBMIT REPORT MODAL */
    const handleSubmit = () => {
      this.setState({ loading: true });
      getMarkerLayers.map((item) => map.removeLayer(item));
      getReportLayer.map((item) => map.removeLayer(item));
      if (isLive) {
        ToggleIsLive();
      }
      if (isMain) {
        ToggleIsMain();
      }
      ClearIconsLayer();
      ClearReportLayer();
      setReports([]);
      SetReportIndex(0);
      if (getInterval) {
        clearInterval(getInterval);
        SetInterval(0);
      }

      if (playPause) {
        TogglePlayPause();
      }

      if (!getReports.length) {
        setReports([]);
      }

      let url = `${getToken}/getReports?phone=${getUser.phone}&id=${CarData.ID}&pass=${getUser.pass}&`;

      if (Day === "time") {
        //FIXME: NEED TIME
        const timeStart = document.getElementById("report_time_start");
        const timeEnd = document.getElementById("report_time_end");
        let from, to;
        if (!!timeStart.value) {
          from = jMoment(
            `${handleJoinDateFromObj(selectedDay.from)} ${timeStart.value}`,
            "jYYYY-jM-jD HH:mm"
          ).format("YYYY/M/D HH:mm");
        } else {
          from = jMoment(
            handleJoinDateFromObj(selectedDay.from),
            "jYYYY-jM-jD"
          ).format("YYYY/M/D");
        }

        if (!!timeEnd.value) {
          to = jMoment(
            `${handleJoinDateFromObj(selectedDay.to)} ${timeEnd.value}`,
            "jYYYY-jM-jD HH:mm"
          ).format("YYYY/M/D HH:mm");
        } else {
          to = jMoment(
            handleJoinDateFromObj(selectedDay.to),
            "jYYYY-jM-jD"
          ).format("YYYY/M/D");
        }

        console.log("FROM : ", from);
        console.log("TO : ", to);

        let startTimeTest = new Date(from);
        let tillTimeTest = new Date(to);
        console.log(startTimeTest);
        console.log(tillTimeTest);

        let startTime = new Date(from).getTime();
        let tillTime = new Date(to).getTime();
        url += `startTime=${startTime}&tillTime=${tillTime}`;
      } else {
        url += `day=${Day}`;
      }

      /** CALCULATE DISTANCE */ /** CALCULATE DISTANCE */ /** CALCULATE DISTANCE */

      function getDistance(origin, destination) {
        // return distance in meters
        let lon1 = toRadian(origin[1]),
          lat1 = toRadian(origin[0]),
          lon2 = toRadian(destination[1]),
          lat2 = toRadian(destination[0]);

        let deltaLat = lat2 - lat1;
        let deltaLon = lon2 - lon1;

        let a =
          Math.pow(Math.sin(deltaLat / 2), 2) +
          Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(deltaLon / 2), 2);
        let c = 2 * Math.asin(Math.sqrt(a));
        let EARTH_RADIUS = 6371;
        return c * EARTH_RADIUS * 1000;
      }

      function toRadian(degree) {
        return (degree * Math.PI) / 180;
      }

      // END CALCULATE DISTANCE
      /** GET REPORT */ /** GET REPORT */ /** GET REPORT */ /** GET REPORT */

      Axios.get(`${url}`).then((res) => {
        if (res.data.success) {
          if (res.data.data.length) {
            setReports(res.data.data);
            /** Start Calculate Distance */

            let previousLongitude = [
              res.data.data[0].Latitude,
              res.data.data[0].Longitude,
            ];

            let Distance = 0;

            res.data.data.map((item) => {
              let distance = getDistance(
                [item.Latitude, item.Longitude],
                previousLongitude
              );

              Distance += distance;

              previousLongitude = [item.Latitude, item.Longitude];
            });

            const KmDistance = Math.round(Distance / 1000);
            // END Calculate Distance

            /** Calculate Fuel */

            const fuelCalculate = (KmDistance * CarData.Fuel) / 100;

            /* END Calculate Fuel */

            /**  START END POINT  */
            let startIcon = L.icon({
              iconUrl: startMark,
              iconAnchor: [2, 60],
              popupAnchor: [2, -20],
              iconSize: new L.Point(45, 62),
            });
            let endIcon = L.icon({
              iconUrl: endMark,
              iconAnchor: [2, 44],
              popupAnchor: [2, -20],
              iconSize: new L.Point(30, 45),
            });
            let arrowIcon = L.icon({
              iconUrl: Arrow,
              iconAnchor: [7, 7],
              popupAnchor: [0, -20],
              iconSize: new L.Point(14, 14),
            });

            let parkIcon = L.icon({
              /** PARK ICON */
              iconUrl: ParkIcon,
              iconAnchor: [15, 40],
              popupAnchor: [0, -20],
              iconSize: new L.Point(30, 40),
            });

            let startMarker = new L.marker(
                [res.data.data[0].Latitude, res.data.data[0].Longitude],
                {
                  icon: startIcon,
                  zIndexOffset: 1,
                }
              ),
              EndMarker = new L.marker(
                [
                  res.data.data[res.data.data.length - 1].Latitude,
                  res.data.data[res.data.data.length - 1].Longitude,
                ],
                {
                  icon: endIcon,
                  zIndexOffset: 2,
                }
              ),
              ArrowMarker = new L.marker(
                [res.data.data[0].Latitude, res.data.data[0].Longitude],
                {
                  icon: arrowIcon,
                  zIndexOffset: 0,
                }
              );

            let showParkIcon;

            for (var i = 0; i < res.data.data.length; i++) {
              let car = res.data.data[i];
              let ParkLayer;

              function shouldHaveParkMarker(data, inx) {
                let now = data[inx];
                let previus = data[inx - 1];
                let next = data[inx + 1];
                if (!now?.park_time || now?.park_time < 300) return null;
                if (next?.park_time >= 300) return null;

                if (previus?.park_time >= 300) {
                  let lastTime = now?.park_time;
                  let index = inx;
                  while (data[index]?.park_time >= 300) {
                    lastTime += data[index]?.park_time;
                    index--;
                  }

                  return { lastParkTime: lastTime, index: inx };
                }
                return { lastParkTime: now?.park_time, index: inx };
              }

              const needMarker = shouldHaveParkMarker(res.data.data, i);

              if (!needMarker) continue;

              if (needMarker.lastParkTime >= 86400) {
                if (!!shouldHaveParkMarker(res.data.data, i))
                  ParkLayer = L.marker([car.Latitude, car.Longitude], {
                    icon: parkIcon,
                  }).bindPopup(
                    `<span>${ToPersianDate(car.Date)}</span><br/>
                                         <span>${`میزان توقف : ${parseInt(
                                           needMarker.lastParkTime / 86400
                                         )} روز و ${parseInt(
                                           (needMarker.lastParkTime % 86400) /
                                             3600
                                         )}ساعت`}</span><br />`
                  );
                showParkIcon = L.layerGroup([ParkLayer]);
                showParkIcon.addTo(map);
                SetIconsLayer(showParkIcon);
              } else if (car?.park_time >= 3600) {
                ParkLayer = L.marker([car.Latitude, car.Longitude], {
                  icon: parkIcon,
                }).bindPopup(
                  `<span>${ToPersianDate(car.Date)}</span><br/>
                                         <span>${`میزان توقف : ${parseInt(
                                           needMarker.lastParkTime / 3600
                                         )} ساعت و ${parseInt(
                                           (needMarker.lastParkTime % 3600) / 60
                                         )}دقیقه`}</span><br />`
                );
                showParkIcon = L.layerGroup([ParkLayer]);
                showParkIcon.addTo(map);
                SetIconsLayer(showParkIcon);
              } else if (car?.park_time >= 300) {
                ParkLayer = L.marker([car.Latitude, car.Longitude], {
                  icon: parkIcon,
                }).bindPopup(
                  `<span>${ToPersianDate(car.Date)}</span><br/>
                                         <span>${`میزان توقف : ${parseInt(
                                           needMarker.lastParkTime / 60
                                         )} دقیقه`}</span><br />`
                );
                showParkIcon = L.layerGroup([ParkLayer]);
                showParkIcon.addTo(map);
                SetIconsLayer(showParkIcon);
              }
            }

            SetArrowIcon(ArrowMarker);

            let StartPopup = `
                                     <div>
                                         <b>شروع حرکت</b><br>
                                         <span>${ToPersianDate(
                                           res.data.data[0].Date
                                         )}</span>
                                     </div>
                                `;
            let EndPopup = `
                                     <div>
                                         <b>پایان حرکت</b><br>
                                         <span>${ToPersianDate(
                                           res.data.data[
                                             res.data.data.length - 1
                                           ].Date
                                         )}</span><br>
                                         <span>میزان مصرف بنزین : ${fuelCalculate} لیتر</span><br>
                                         <span>مسافت طی شده : ${KmDistance}کیلومتر </span>
                                     </div>
                                `;

            startMarker.bindPopup(StartPopup);
            EndMarker.bindPopup(EndPopup);

            // END START END POINT

            /** START ANT-PATH */

            let arrs = [];
            res.data.data.map((item) => {
              arrs.push([item.Latitude, item.Longitude]);
            });

            const path = antPath(arrs, {
              paused: false,
              reverse: false,
              delay: 3000,
              dashArray: [3, 100],
              weight: 5,
              opacity: 0.6,
              color: "#0000FF",
              pulseColor: "#FFFFFF",
            });

            /* END ANT-PATH */
            /** CLEAR AND SET MAP AGAIN */

            this.setState({ loading: false });
            ToggleReports();
            getMarkerLayers.map((item) => map.removeLayer(item));
            let ReportsLayer = L.layerGroup([
              startMarker,
              EndMarker,
              ArrowMarker,
              path,
            ]);
            SetIconsLayer(ReportsLayer);
            map.flyTo(
              [res.data.data[0].Latitude, res.data.data[0].Longitude],
              15
            );
            map.addLayer(ReportsLayer);
          } else {
            Alert.error(
              "دستگاه مورد نظر در روز انتخاب شده حرکتی نداشته است",
              5000
            );
            this.setState({ loading: false });
          }
        } else {
          Alert.error(
            "مشکلی در برقراری ارتباط وجود دارد لطفا دوباره تلاش کنید."
          );
          this.setState({ loading: false });
        }
      });
    };

    /** HANDLE EXIT BTN */
    const handleExitBtn = () => {
      let map = getMap;
      if (!isMain) {
        ToggleIsMain();
      }
      setReports([]);
      SetReportIndex(0);
      if (playPause) {
        TogglePlayPause();
      }
      if (getInterval) {
        SetInterval(0);
        clearInterval(getInterval);
      }
      getMarkerLayers.map((item) => map.removeLayer(item));
      getReportLayer.map((x) => map.removeLayer(x));
      ClearIconsLayer();
      ClearReportLayer();

      map.flyTo([singleCar.Latitude, singleCar.Longitude], 16);
    };
    // END HANDLE EXIT BTN

    /** PLAY HANDLER */
    const handlePlayReport = () => {
      TogglePlayPause();
      getMarkerLayers.map((item) => map.removeLayer(item));

      if (getReportIndex >= getReports.length - 1) {
        SetReportIndex(0);
        clearInterval(getInterval);
        SetInterval(0);
      }

      //INTERVAL INTERVAL INTERVAL INTERVAL INTERVAL INTERVAL INTERVAL
      var index = getReportIndex;
      var interval = setInterval(() => {
        let setCar0 = () => {
          if (index < getReports.length - 1) {
            return getReports[index + 1];
          } else {
            return getReports[getReports.length - 2];
          }
        };

        let setCar1 = () => {
          if (index < getReports.length - 1) {
            return getReports[index];
          } else {
            return getReports[getReports.length - 1];
          }
        };

        let car = setCar0();
        let car1 = setCar1();

        let parkIcon = L.icon({
          /** PARK ICON */
          iconUrl: ParkIcon,
          iconAnchor: [15, 40],
          popupAnchor: [0, -20],
          iconSize: new L.Point(30, 40),
        });

        var x = getArrowIcon
          .setLatLng([car.Latitude, car.Longitude])
          .bindPopup(
            `<span>${ToPersianDate(car.Date)}</span><br/>
                                <span>سرعت : ${car.Speed}</span><br/>
                                <span>دما : ${car.Temperature}</span>`
          )
          .openPopup();

        map.setView([car.Latitude, car.Longitude], 15);

        let LineLayer = new L.Polyline([
          [car.Latitude, car.Longitude],
          [car1.Latitude, car1.Longitude],
        ]);

        // PARK STATE
        let ShowPath;
        let PTime = car?.park_time;
        let ParkLayer;
        if (PTime >= 86400) {
          ParkLayer = L.marker([car.Latitude, car.Longitude], {
            icon: parkIcon,
          }).bindPopup(
            `<span>${ToPersianDate(car.Date)}</span><br/>
                             <span>${`میزان توقف : ${parseInt(
                               PTime / 86400
                             )} روز و ${parseInt(
                               (PTime % 86400) / 3600
                             )}ساعت`}</span><br />`
          );
          ShowPath = L.layerGroup([LineLayer, x, ParkLayer]);
        } else if (car?.park_time >= 3600) {
          ParkLayer = L.marker([car.Latitude, car.Longitude], {
            icon: parkIcon,
          }).bindPopup(
            `<span>${ToPersianDate(car.Date)}</span><br/>
                             <span>${`میزان توقف : ${parseInt(
                               PTime / 3600
                             )} ساعت و ${parseInt(
                               (PTime % 3600) / 60
                             )}دقیقه`}</span><br />`
          );
          ShowPath = L.layerGroup([LineLayer, x, ParkLayer]);
        } else if (car?.park_time >= 300) {
          ParkLayer = L.marker([car.Latitude, car.Longitude], {
            icon: parkIcon,
          }).bindPopup(
            `<span>${ToPersianDate(car.Date)}</span><br/>
                             <span>${`میزان توقف : ${parseInt(
                               PTime / 60
                             )} دقیقه`}</span><br />`
          );
          ShowPath = L.layerGroup([LineLayer, x, ParkLayer]);
        } else {
          ShowPath = L.layerGroup([LineLayer, x]);
        }

        ShowPath.addTo(map);

        index++;

        SetReportIndex(index);
        if (index === getReports.length) {
          clearInterval(interval);
          handlePauseReport();
        }
        addReportLayer(ShowPath);
      }, getReportSpeed);

      SetInterval(interval);
    };
    //END PLAY HANDLER

    /** PAUSE HANDLER */
    const handlePauseReport = () => {
      TogglePlayPause();
      clearInterval(getInterval);
    };
    //END PAUSE HANDLER

    const HandleChangeSlider = (value) => {
      if (playPause) {
        TogglePlayPause();
        clearInterval(getInterval);
      }
      SetReportIndex(value);
    };

    const handleStyle = {
      color: "#fff",
      fontSize: 12,
      width: 27,
      height: 19,
      backgroundImage: `url(${carSeek})`,
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
    };

    /** RETURN */
    return (
      <div>
        <Modal size="xs" show={ReportsModal} onHide={() => ToggleReports()}>
          <Modal.Header>
            <Modal.Title>گزارش {CarData.NAME}</Modal.Title>
          </Modal.Header>
          <Form
            onChange={(formValue) => {
              this.setState({ formValue });
            }}
            onSubmit={() => handleSubmit()}
            formValue={formValue}
          >
            <Modal.Body style={{ overflow: "unset" }}>
              <FormGroup>
                <FormControl
                  name="period"
                  inline
                  accepter={RadioGroup}
                  onChange={(day) => ChangeDay(day)}
                >
                  <Radio value={0}>امروز</Radio>
                  <Radio value={1}>دیروز</Radio>
                  <Radio value={2}>سه روزه پیش</Radio>
                  <Radio value="time">انتخاب زمان</Radio>
                </FormControl>
              </FormGroup>

              {!!formValue && formValue.period === "time" ? (
                <div className="calendar_div">
                  <FormGroup>
                    <ControlLabel>انتخاب تاریخ</ControlLabel>
                    <DatePicker
                      locale="fa"
                      shouldHighlightWeekends
                      value={selectedDay}
                      onChange={(selectedDay) => this.setState({ selectedDay })}
                      calendarClassName="custom_datePicker"
                    />
                  </FormGroup>
                  <div className="calendar_time">
                    <FormGroup>
                      <ControlLabel>از ساعت</ControlLabel>
                      <input type="time" id="report_time_start" />
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>از ساعت</ControlLabel>
                      <input type="time" id="report_time_end" />
                    </FormGroup>
                  </div>
                </div>
              ) : null}
              <FormGroup>
                <ControlLabel style={{ fontSize: "17px", fontWeight: "400" }}>
                  انتخاب سرعت پخش گزارش :
                </ControlLabel>
                <FormControl
                  accepter={RadioGroup}
                  name="speed"
                  onChange={(speed) => setReportSpeed(speed)}
                  inline
                >
                  <Radio value={50} name="veryFast">
                    سریع
                  </Radio>
                  <Radio value={200} name="fast">
                    زیاد
                  </Radio>
                  <Radio value={400} name="mid">
                    متوسط
                  </Radio>
                  <Radio value={600} name="low">
                    کم
                  </Radio>
                </FormControl>
              </FormGroup>
            </Modal.Body>
            <Modal.Footer>
              <Row>
                <Col xs={24}>
                  <Button
                    onClick={() => handleGetExcel()}
                    color="cyan"
                    block
                    style={{ marginBottom: "10px" }}
                  >
                    <Icon icon="file-download" /> دانلود فایل گزارش{" "}
                    <small>(اکسل)</small>
                  </Button>
                </Col>
              </Row>

              <Row>
                <Col xs={12}>
                  <Button
                    onClick={() => ToggleReports()}
                    className="BtnClose"
                    block
                  >
                    بستن
                  </Button>
                </Col>
                <Col xs={12}>
                  <Button
                    className="Btn1"
                    block
                    type="submit"
                    loading={this.state.loading}
                  >
                    گرفتن گزارش
                  </Button>
                </Col>
              </Row>
            </Modal.Footer>
          </Form>
        </Modal>
        {getReports.length ? (
          <div className="report-option">
            {playPause ? (
              <Button onClick={() => handlePauseReport()}>
                <img src={Pause} alt="" />
              </Button>
            ) : (
              <Button
                onClick={() => handlePlayReport()}
                disabled={getReportIndex === getReports.length}
              >
                <img src={Play} alt="" />
              </Button>
            )}
            <Slider
              progress
              // renderMark={(mark) => console.log(mark)}
              min={0}
              max={getReports.length}
              value={getReportIndex}
              onChange={(value) => HandleChangeSlider(value)}
              className="report-slider"
              tooltip={false}
              handleStyle={handleStyle}
            />
            <Button>
              <img
                src={buttonOff}
                style={{ transform: "scale(1.2)" }}
                alt=""
                onClick={() => handleExitBtn()}
              />
            </Button>
          </div>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  ReportsModal: selectReportsModal,
  CarsData: selectCarsData,
  CarData: selectSelectedCarInfo,
  getUser: selectUserInfo,
  singleCar: selectSingleCarData,
  getMap: selectMap,
  getMarkerLayers: selectIconsLayer,
  getReports: selectReports,
  Day: selectDay,
  playPause: selectPlayPause,
  getInterval: selectInterval,
  getReportIndex: selectReportIndex,
  getReportLayer: selectReportLayer,
  getReportSpeed: selectReportSpeed,
  isLive: selectIsLive,
  isMain: selectIsMain,
  getArrowIcon: selectArrowIcon,
  GetEndRepTime: selectEndRepTime,
  GetStartRepTime: selectStartRepTime,
  getToken: selectToken,
  ReceivedExcel: selectReceivedExcel,
});

const mapDispatchToProps = (dispatch) => ({
  ToggleReports: () => dispatch({ type: modalsTypes.TOGGLE_REPORTS_MODAL }),
  setReports: (reports) => dispatch(GetReports(reports)),
  ChangeDay: (day) => dispatch(ChangeDay(day)),
  SetIconsLayer: (layer) => dispatch(SetIconsLayer(layer)),
  setCars: (res) => dispatch(GetCarsData(res)),
  TogglePlayPause: () => dispatch({ type: carsTypes.PLAY_PAUSE }),
  SetInterval: (interval) => dispatch(SetInterval(interval)),
  SetReportIndex: (index) => dispatch(SetReportIndex(index)),
  addReportLayer: (newLayer) => dispatch(AddReportLayer(newLayer)),
  ClearReportLayer: () => dispatch({ type: mapTypes.CLEAR_REPORT_LAYER }),
  ClearIconsLayer: () => dispatch({ type: mapTypes.CLEAR_ICONS_LAYER }),
  setReportSpeed: (speed) => dispatch(SetReportSpeed(speed)),
  ToggleIsLive: () => dispatch({ type: mapTypes.TOGGLE_IS_LIVE }),
  ToggleIsMain: () => dispatch({ type: mapTypes.TOGGLE_IS_MAIN }),
  SetArrowIcon: (Icon) => dispatch(SetArrowIcon(Icon)),
  setStartRepTime: (Stime) => dispatch(SetStartRepTime(Stime)),
  setEndRepTime: (Etime) => dispatch(SetEndtRepTime(Etime)),
  setReceivedExcel: (href) => dispatch(SetReceivedExcel(href)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportsComponent);
